import { useTranslation } from "react-i18next";
import { DraftCard } from "../DraftCard";
import { useDraftContext } from "../DraftContext";
import type { EntityDraftCardProps } from "../registry";
import { useWorkflowDraft, type WorkflowDraftBody } from "./useWorkflowDraft";
import { WorkflowDraftSummary } from "./WorkflowDraftSummary";

/** A workflow draft: Create makes the flow with its steps, then its triggers; Save replaces the steps. */
export function WorkflowDraftCard({ draft, state, entityUuid, updatedAt, answerable }: Readonly<EntityDraftCardProps>) {
  const { t } = useTranslation("buildChat");
  const { linked } = useDraftContext();
  const workflow = useWorkflowDraft(draft);
  return (
    <DraftCard
      title={workflow.flow.name ?? linked.find((e) => e.uuid === draft.targetUuid)?.name ?? t("draft.untitled")}
      entityLabel={t("draft.entity.workflow")}
      state={state}
      isUpdate={Boolean(draft.targetUuid)}
      doneUuid={workflow.doneUuid}
      entityUuid={entityUuid}
      updatedAt={updatedAt}
      missingFields={draft.missingFields}
      questions={draft.questions}
      answerable={answerable}
      busy={workflow.busy}
      steps={workflow.steps}
      onCreate={workflow.run}
      onRetry={workflow.retry}
      onOpenInForm={workflow.openInForm}
      detailPath={(uuid) => `/build/workflows/${uuid}`}
      summary={<WorkflowDraftSummary body={draft.draft as WorkflowDraftBody} isUpdate={Boolean(draft.targetUuid)} />}
    />
  );
}
